import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import theme from './theme';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Outcomes from './components/Outcomes';
import HowWeWork from './components/HowWeWork';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import AdminPanel from './components/AdminPanel';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

const HomePage = () => (
  <>
    <Hero />
    <Services />
    <Outcomes />
    <HowWeWork />
    <Contact />
  </>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            maxWidth: '100%',
            overflowX: 'clip',
          }}
        >
          <Header />
          <Box component="main" sx={{ flexGrow: 1, maxWidth: '100%', overflowX: 'clip' }}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/privacidad" element={<PrivacyPage />} />
              <Route path="/terminos" element={<TermsPage />} />
            </Routes>
          </Box>
          <Footer />
          <WhatsAppButton />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
